import TodoForm from "../../components/TodoForm/TodoForm";

const AddTodo = () => {
    return <TodoForm />
}

export default AddTodo